import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

const MenuElements = ({ menuElements }) =>
  menuElements.map((menuElement, index) => {
    return (
      <Li
        className={`${menuElement.attrs.className} popdown-item`}
        onClick={e => {
          e.stopPropagation();
          menuElement.clickEvent(e);
        }}
        key={index}
        {...menuElement.attrs}
      >
        {menuElement.faIcon ? (
          <Icon className={`${menuElement.faIcon}`} />
        ) : null}
        <Span className="popdown-menu-span">{menuElement.text}</Span>
      </Li>
    );
  });

const PopdownMenu = ({
  dropdownId,
  afterHide,
  afterShow,
  menuProps,
  menuElements,
}) => (
  <ReactTooltip
    key={`tooltip-${dropdownId}`}
    id={`dropdown-${dropdownId}`}
    afterHide={afterHide}
    afterShow={afterShow}
    ariaHaspopup="true"
    effect="solid"
    globalEventOff="click"
    offset={{ right: '45', top: '7' }}
    place="bottom"
    role="dropdown"
    type="light"
  >
    <ul
      style={{ pointerEvents: 'all' }}
      key={`ul-${dropdownId}`}
      {...menuProps}
    >
      <MenuElements menuElements={menuElements} />
    </ul>
  </ReactTooltip>
);

PopdownMenu.propTypes = {
  afterHide: PropTypes.func,
  afterShow: PropTypes.func,
  dropdownId: PropTypes.any.isRequired,
  menuElements: PropTypes.array.isRequired,
  menuProps: PropTypes.object,
};

export { PopdownMenu };

export default PopdownMenu;

const Li = styled.li`
  border-bottom: solid 1px #d8d8d8;
  color: #5a5a5a;
  font-family: Avenir Next Airbo;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  height: 29px;
  letter-spacing: normal;
  line-height: 2.08;
  padding-left: 12px;
  width: 100%;

  &:last-child {
    border: none;
  }

  &:hover {
    color: #007eff !important;
    background-color: rgba(0, 126, 255, 0.04);
  }
`;

const Icon = styled.i`
  display: inline-block;
  padding-right: 5%;
  min-width: 18px;
`;

const Span = styled.span`
  display: inline-block;
  line-height: 18px;
  margin: 5px;
`;
